import { render, staticRenderFns } from "./CustomersTable.vue?vue&type=template&id=71209a1a&scoped=true&"
import script from "./CustomersTable.vue?vue&type=script&lang=ts&"
export * from "./CustomersTable.vue?vue&type=script&lang=ts&"
import style0 from "./CustomersTable.vue?vue&type=style&index=0&id=71209a1a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71209a1a",
  null
  
)

export default component.exports